import { Facebook, Instagram, Youtube } from "lucide-react";
import { LogoMark } from "./Logo";
import {
  NAV_LINKS,
  ADDRESS_LINES,
  WA_DEFAULT,
  PHONE_CALL_TEL,
  PHONE_WHATSAPP_DISPLAY,
  PHONE_CALL_DISPLAY,
} from "./data";
import { scrollToId } from "@/lib/lenis";

const SOCIALS = [
  { icon: Facebook, label: "Facebook", href: "https://www.facebook.com/share/1A3A9Fo1TN/" },
  { icon: Instagram, label: "Instagram", href: "https://www.instagram.com/liftedge.hercules" },
  { icon: Youtube, label: "YouTube", href: null },
];

const SocialIcon = ({ icon: Icon, label, href }) =>
  href ? (
    <a
      href={href}
      target="_blank"
      rel="noopener noreferrer"
      title={`Lift Edge on ${label}`}
      aria-label={`Lift Edge on ${label}`}
      data-testid={`footer-social-${label.toLowerCase()}`}
      className="flex h-10 w-10 items-center justify-center border border-line text-ash transition-colors duration-200 hover:border-edge hover:text-white"
    >
      <Icon size={16} />
    </a>
  ) : (
    <span
      title={`${label} — link coming soon`}
      aria-label={`${label} (coming soon)`}
      data-testid={`footer-social-${label.toLowerCase()}`}
      className="flex h-10 w-10 cursor-not-allowed items-center justify-center border border-line text-dim"
    >
      <Icon size={16} />
    </span>
  );

export const FooterBrand = () => (
  <div>
    <span className="flex items-center gap-2.5 text-white">
      <LogoMark className="h-9 w-auto" />
      <span className="leading-none">
        <span className="block font-display text-2xl font-extrabold uppercase tracking-wide">Lift Edge</span>
        <span className="block font-mono text-[9px] uppercase tracking-[0.28em] text-ash">Hercules Fitness Store</span>
      </span>
    </span>
    <p className="mt-5 font-display text-lg font-bold uppercase tracking-wide text-edge">
      Your Trusted Fitness Equipment Partner
    </p>
    <p className="mt-3 text-sm leading-relaxed text-ash">
      Exclusive Hercules Fitness Showroom
      <br />
      Distributor — North Bengal, Sikkim, Bihar, West Bengal, Nepal & Bhutan
    </p>
    <div className="mt-6 flex gap-3">
      {SOCIALS.map((s) => (
        <SocialIcon key={s.label} {...s} />
      ))}
    </div>
  </div>
);

export const FooterLinks = () => (
  <div>
    <p className="mb-5 font-mono text-[11px] uppercase tracking-[0.3em] text-dim">Quick Links</p>
    <ul className="space-y-3" data-testid="footer-quick-links">
      {NAV_LINKS.map((l) => (
        <li key={l.hash}>
          <a
            href={l.hash}
            onClick={(e) => {
              e.preventDefault();
              scrollToId(l.hash);
            }}
            className="font-display text-lg font-bold uppercase tracking-wide text-ash transition-colors duration-200 hover:text-edge"
          >
            {l.label}
          </a>
        </li>
      ))}
    </ul>
  </div>
);

export const FooterReach = () => (
  <div>
    <p className="mb-5 font-mono text-[11px] uppercase tracking-[0.3em] text-dim">Reach Us</p>
    <address className="space-y-1 text-sm not-italic leading-relaxed text-ash">
      {ADDRESS_LINES.map((line) => (
        <p key={line}>{line}</p>
      ))}
    </address>
    <div className="mt-5 space-y-2 text-sm">
      <a
        href={WA_DEFAULT}
        target="_blank"
        rel="noopener noreferrer"
        className="block text-ash transition-colors hover:text-wa"
        data-testid="footer-whatsapp-link"
      >
        WhatsApp: {PHONE_WHATSAPP_DISPLAY}
      </a>
      <a
        href={`tel:${PHONE_CALL_TEL}`}
        className="block text-ash transition-colors hover:text-white"
        data-testid="footer-call-link"
      >
        Call: {PHONE_CALL_DISPLAY}
      </a>
    </div>
  </div>
);
